var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Homematic")]),_c('hmip-thermostat',{attrs:{"device":_vm.states['3261']}}),_c('div',[_vm._v(_vm._s(_vm.rooms))]),_c('div',[_vm._v(_vm._s(_vm.states))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }